import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PortInactiveVesselsComponent } from './port-inactive-vessels.component';

import { MaterialModule } from 'src/app/shared/material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';
import { CustomDatePickerModule } from 'src/app/shared/components/custom-date-picker/custom-date-picker.module';
import { PcMultiSelectFilterModule } from 'src/app/shared/components/pc-multi-select-filter/pc-multi-select-filter.module';
import { CustomInputModule } from 'src/app/shared/components/custom-input/custom-input.module';
import { ExpansionPanelModule } from "src/app/shared/components/expansion-panel/expansion-panel.module";

@NgModule({
  declarations: [PortInactiveVesselsComponent],
  imports: [
    CommonModule,
    CustomDatePickerModule,
    PcMultiSelectFilterModule,
    CustomInputModule,
    MaterialModule,
    FormsModule,
    MatPaginatorModule,
    ReactiveFormsModule,
    ExpansionPanelModule
],
  exports: [PortInactiveVesselsComponent],
})
export class PortInactiveVesselsModule {}
